// extracted by mini-css-extract-plugin
module.exports = {"OrderTimesWrapper":"TransactionPage_OrderTimesWrapper__82rnh","OrderTime":"TransactionPage_OrderTime__3Bh1V","transactionPage":"TransactionPage_transactionPage__25sRX"};